(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4539],{

/***/ 4539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_AppFeaturesItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/AppFeaturesItem/utils/useAppFeaturesItem.js

var useAppFeaturesItem = function(param) {
    var type = param.type, view = param.view, data = param.data, currentIndex = param.currentIndex, activeIndex = param.activeIndex, handleOnClick = param.handleOnClick, className = param.className;
    var ref = (0,helper/* getDocumentFields */.OA)(data, [
        "title",
        "text",
        "imagesBundles",
        "contentList", 
    ]), title = ref.title, text = ref.text, imagesBundles = ref.imagesBundles, contentList = ref.contentList;
    var imagesUrl = (imagesBundles === null || imagesBundles === void 0 ? void 0 : imagesBundles.map(function(imagesBundle) {
        return (0,helper/* getFileUrl */.qm)(imagesBundle);
    })) || [];
    return {
        type: type,
        view: view,
        title: title,
        text: text,
        imagesUrl: imagesUrl,
        activeIndex: activeIndex,
        currentIndex: currentIndex,
        handleOnClick: handleOnClick,
        customIcon: contentList === null || contentList === void 0 ? void 0 : contentList[0],
        className: className
    };
};

// EXTERNAL MODULE: ./UI/components/AppFeaturesItem/styles.module.scss
var styles_module = __webpack_require__(43296);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/AppFeaturesItem/index.jsx













var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var AppFeaturesItem = function(props) {
    var ref = useAppFeaturesItem(props), type = ref.type, view = ref.view, title = ref.title, text = ref.text, activeIndex = ref.activeIndex, currentIndex = ref.currentIndex, handleOnClick = ref.handleOnClick, imagesUrl = ref.imagesUrl, customIcon = ref.customIcon, className = ref.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        delay: 75 * currentIndex
    }, constants/* REVEAL_ANIMATION_PROPS */.kt), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((styles_module_default()).sectionItem, (styles_module_default())[type], (styles_module_default())[view], className, (0,_define_property/* default */.Z)({}, (styles_module_default()).sectionActiveItem, currentIndex === activeIndex)),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    role: "presentation",
                    className: (styles_module_default()).wrapperTitle,
                    onClick: handleOnClick(currentIndex),
                    children: [
                        customIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                            type: customIcon,
                            className: (styles_module_default()).icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (styles_module_default()).title,
                            children: title
                        }),
                        imagesUrl.map(function(imageUrl) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                className: (styles_module_default()).imageBundle,
                                src: imageUrl,
                                alt: ""
                            }, "bundles-images/".concat(imageUrl));
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                            type: "chevronDown",
                            className: (styles_module_default()).expandIcon
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, {
                    open: currentIndex === activeIndex,
                    type: constants/* ANIMATED_TYPE.expandByHeight */.BK.expandByHeight,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((styles_module_default()).description, (0,_define_property/* default */.Z)({}, (styles_module_default()).withIcon, customIcon)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                            document: text
                        })
                    })
                })
            ]
        })
    }), title);
};
AppFeaturesItem.propTypes = {
    data: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired
};
/* harmony default export */ var components_AppFeaturesItem = (AppFeaturesItem);


/***/ }),

/***/ 43296:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionItem":"styles_sectionItem__FdrVe","wrapperTitle":"styles_wrapperTitle__Zb0CI","title":"styles_title__mXSVd","description":"styles_description__cVeAW","withIcon":"styles_withIcon__RELPO","imageBundle":"styles_imageBundle__oKqaU","icon":"styles_icon__rGYrV","expandIcon":"styles_expandIcon__2lf6f","sectionActiveItem":"styles_sectionActiveItem__iBshL","fintech-software-development-services":"styles_fintech-software-development-services___I5gv","enterprise-resource-planning-software-services":"styles_enterprise-resource-planning-software-services__qke8W","discovery-phase-services":"styles_discovery-phase-services__0NmMG","secondSectionView":"styles_secondSectionView__iVE0_","prototyping-services":"styles_prototyping-services__qDU4N","lending-software-development":"styles_lending-software-development__wEFaO","banking-software-development-company":"styles_banking-software-development-company__kQrLx"};

/***/ })

}]);